import { z } from "zod";

const zSubjectSchema = z.enum(["I_D_LIKE_TO_ORDER", "SERVICE_QUESTIONS", "OTHER"]);
const SubjectSchema = zSubjectSchema.Enum;
type SubjectSchema = z.infer<typeof zSubjectSchema>;

export { SubjectSchema, zSubjectSchema };
